<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <card title="افسانه سیزیف"
          description="سیزیف در اساطیر یونان بخاطر فاش کردن راز خدایگان محکوم شد تا تخته سنگی را به دوش گرفته و تا قله یک کوه حمل کند، اما همین که به قله می‌رسد، سنگ به پایین می‌غلتد و سیزیف باید دوباره این کار را انجام دهد.کامو می‌گوید پیروزی وی در آگاهی است."
          link="#a" />
      </div>
      <div class="col-sm-6">
        <card title="بیگانه"
          description="من مدت‌ها قبل بیگانه را خلاصه کردم، با یک اظهار نظر اعتراف می‌کنم خیلی متناقض بود: «در جامعهٔ ما هر مردی که در مراسم تشییع جنازهٔ مادرش گریه نکند، با خطر محکومیت به اعدام مواجه می‌شود». فقط منظورم این بود که قهرمان کتاب من به این دلیل محکوم می‌شود که در این بازی شرکت نمی‌کند"
          link="#b" />
      </div>
      <div class="col-sm-6">
        <card title="طاعون"
          description="آنگاه پی بردم که دست کم من در سراسر این سال های دراز طاعون زده بوده‌ام و با وجود باهمه صمیمیتم گمان کرده‌ام که بر ضد طاعون می‌جنگم."
          link="#t" />
      </div>

    </div>
    <hr>
    <hr>
    <br>
    <section id="section-intro" class="sections">
      <div id="intro-container" align="right" dir="rtl">
        <h3 id="t">طاعون - مهلکی مفید</h3>
        <br>
        <figcaption class="blockquote-footer">
          منتشر شده توسط مهران در تاریخ <cite title="Source Title">عید ۱۴۰۳</cite>
        </figcaption>
        <p>وقایع رمان در شهری از الجزایر به نام اُران یا وهران رخ می‌دهد و از زبان راوی که بعدها خود را دکتر ریو معرفی
          می‌کند نقل می‌شود. کتاب با توضیحی از مردم و شهر آغاز می‌شود و سپس به زیاد شدن تعداد موش‌ها در شهر و مرگ آن‌ها
          اشاره می‌کند. آقای میشل، سرایدار منزل دکتر ریو بر اثر بیماری‌ای با بروز تاول‌ها و خیارک‌ها می‌میرد و مرگ چند
          نفر
          دیگر با همین علائم باعث می‌شود دکتر ریو علت مرگ را بیماری احتمالاً مسری بداند و کمی بعد دکتر کاستل این بیماری
          را
          طاعون تشخیص می‌دهد. با سستی مسئولین برای واکنش، بعد از مدتی در شهر طاعون و وضع قرنطینه اعلام می‌شود.
          <br><br>
          با اعلام وضع قرنطینه، اعضای خانواده‌های زیادی از هم جدا ماندند. عده‌ای اقدام به فرارهای متوالی کردند و عده‌ای
          تا
          جایی که می‌توانستند با بیماری مبارزه کردند. ژان تارو یکی از مسافرانی بود که همراه با دکتر ریو اقدام به تشکیل
          سازمان بهداشتی داوطلبی برای مقابله با بیماری می‌کند.
          <br><br>
          کشیش شهر، پدر پانلو، با ایراد سخنرانی در آغاز اعلام وضع طاعون مردم را به گناه محکوم می‌کند و طاعون را مجازاتی
          برای همگان می‌خواند که به علت گناه کردن و توبه نکردن مردم نازل شده بود؛ بنابراین طاعون را تربیت‌کننده و اقدام
          علیه آن را بی‌فایده خواند و از مردم خواست آرامش خود را حفظ کنند که این ارادهٔ خداوند است و باقی کارها با
          خداست.
          <br><br>
          با مرگ و میر سریع، بیشتر مؤسسات و سازمان‌های دولتی به اردوگاه‌های قرنطینه برای افراد خانوادهٔ بیماران یا
          بیمارستان تبدیل شدند. دفن دسته جمعی اجساد جای خود را به کوره‌های جسدسوزی داد و از راه‌آهن تنها برای حمل اجساد
          استفاده شد.
          <br><br>
          در این مدت آقای کتار که قبل از طاعون اقدام به خودکشی کرد و توسط گران نجات یافت، روابط اجتماعی خوبی برقرار کرد
          و
          از وضع طاعون راضی بود. رامبر روزنامه‌نگار جوان هم با اعلام وضع قرنطینه چندین بار برای رسیدن به معشوقش برنامهٔ
          فرار چید، اما با مهیا شدن شرایط، وقتی تارو به او گفت ریو نیز از همسرش که به علت بیماری در شهر دیگری است جدا
          مانده، نظرش را تغییر داد و به گروه نجات پیوست. پدر پانلو نیز به گروه نجات پیوست و با دیدن مرگ سخت و دردناک پسر
          قاضی اُتون، با ایراد موعظه‌ای دیگر از لفظ «ما» به جای «شما» استفاده کرد و مرگ پسر را آزمایشی الهی می‌خواند و
          از
          مردم خواست با بیماری مقابله کنند. مدتی بعد وی نیز بر اثر بیماری‌ای که دکتر ریو آن را مشکوک اعلام کرد، درگذشت.
          <br><br>
          سرم کاستل برای چند مورد موفقیت پیدا کرد. گران با علائم طاعون ریوی و خیارکی نجات یافت. قاضی اُتون پس از مرگ
          پسرش
          و به اتمام رسیدن دوران قرنطینه خود، برای کمک به اردوگاه بازمی‌گردد و در آنجا می‌میرد. تعداد کشته‌شدگان بیماری
          به
          مقدار ثابتی می‌رسد و با رسیدن فصل سرما کم و کمتر می‌شود و در زمانی که موش‌ها دوباره بیرون آمدند و ترس از طاعون
          کم می‌شد، بیماری آخرین قربانی خود یعنی تارو را دربر گرفت.
          <br><br>
          پس از پایان طاعون، مردم به کارهای روزمره بازمی‌گردند. رامبر به معشوقش می‌رسد. کتار به علت تیراندازی به خیابان
          توسط پلیس دستگیر می‌شود. دکتر ریو که چند روز قبل از مرگ همسر بیمارش با خبر می‌شود، به مراسم شادی نگاه می‌کند و
          با خود می‌گوید باسیل طاعون می‌تواند سال‌ها در شهر زنده بماند و بار دیگر به شهر هجوم کند.
        </p>
        <hr>
        <br>
        <h3 id="b">بیگانه - پوچ انگاری دقیق</h3>
        <br>
        <figcaption class="blockquote-footer">
          منتشر شده توسط مهران در تاریخ <cite title="Source Title">عید ۱۴۰۳</cite>
        </figcaption>
        <p>
          این کتاب داستان یک مرد درونگرا به نام مرسو را تعریف می‌کند که مرتکب قتلی می‌شود و در سلول زندان در انتظار
          اعدام
          خویش است. داستان در دههٔ ۳۰ در الجزایر رخ می‌دهد.
          <br><br>
          داستان به دو قسمت تقسیم می‌شود. در قسمت اول مرسو در مراسم تدفین مادرش شرکت می‌کند و در عین حال هیچ تأثر و
          احساس
          خاصی از خود نشان نمی‌دهد. داستان با ترسیم روزهای بعد از دید شخصیت اصلی داستان ادامه می‌یابد. مرسو به عنوان
          انسانی بدون هیچ اراده به پیشرفت در زندگی ترسیم می‌شود. او هیچ رابطهٔ احساسی بین خود و افراد دیگر برقرار
          نمی‌کند
          و در بی‌تفاوتی خود و پیامدهای حاصل از آن زندگی اش را سپری می‌کند. او از این که روزهایش را بدون تغییری در
          عادت‌های خود می‌گذراند خشنود است.
          <br><br>
          همسایهٔ مرسو که ریمون سنته نام دارد و متهم به فراهم آوردن شغل برای روسپیان است با او رفیق می‌شود. مرسو به سنته
          کمک می‌کند یک معشوقهٔ او را که سنته ادعا می‌کند دوست دختر قبلی او است به سمت خود بکشد. سنته به آن زن فشار
          می‌آورد و او را تحقیر می‌کند. مدتی بعد مرسو و سنته کنار ساحل به برادر آن زن («مرد عرب») و دوستانش برمی‌خورند.
          اوضاع از کنترل خارج می‌شود و کار به کتک‌کاری می‌کشد. پس از آن مرسو بار دیگر «مرد عرب» را در ساحل می‌بیند و این
          بار کس دیگری جز آن‌ها در اطراف نیست. بدون دلیل مشخص مرسو به سمت مرد عرب تیراندازی می‌کند که در فاصلهٔ امنی از
          او
          از سایهٔ صخره‌ای در گرمای سوزنده لذت می‌برد.
          <br><br>
          در قسمت دوم کتاب محاکمهٔ مرسو آغاز می‌شود. در این‌جا شخصیت اول داستان برای اولین بار با تأثیری که بی اعتنایی و
          بی‌تفاوتی برخورد او بر دیگران می‌گذارد رو به رو می‌شود. اتهام راست بی خدا بودنش را بدون کلامی می‌پذیرد. او
          رفتار
          اندولانت (اصطلاح روان‌شناسی برای کسی که در مواقع قرار گرفتن در وضعیت‌های خاص از خود احساس متناسب نشان نمی‌دهد
          و
          بی اعتناء باقی می‌ماند- از درد تأثیر نمی‌پذیرد یا آن را حس نمی‌کند) خود را به عنوان قانون منطقی زندگی‌اش تفسیر
          می‌کند. او به اعدام محکوم می‌شود. آلبر کامو در این رمان آغازی برای فلسفهٔ پوچی خود که بعد به چاپ می‌رسد، فراهم
          می‌آورد.
        </p>
        <hr>
        <br>
        <h3 id="a">افسانه سیزیف - شکنجه‌ای بزرگ تر از کار بیهوده نیست</h3>
        <br>
        <figcaption class="blockquote-footer">
          منتشر شده توسط مهران در تاریخ <cite title="Source Title">عید ۱۴۰۳</cite>
        </figcaption>
        <p>
          کامو در این فصل می‌گوید تنها یک مسئله مهم فلسفی موجود است و آن خودکشی است. اینکه آیا زندگی ارزش دارد یا به
          زحمت
          زیستنش نمی‌ارزد. فهمیدن این که این جهان پوچ است کار سختی نیست اما آیا این پوچی ما را به خودکشی رهنمون می‌سازد؟
          فصل ۲:انسان پوچ
          <br><br>
          در این فصل، کامو مواردی از زندگی ابزورد را معرفی می‌کند. اولین موردی که وی اشاره می‌کند دن خوان، اغواگر سریالی
          زنان است که تا جایی که می‌تواند زندگی پرشور و شهوت‌انگیزی دارد. «هیچ عشقی اصیل نیست، مگر عشقی که کوتاه مدت و
          استثنایی باشد».
          <br><br>
          مثال بعدی، در مورد بازیگری است که زندگی‌های کوتاه را برای کسب افتخارهای بیشمار نمایش می‌دهد.
          <br><br>
          مورد آخر و سوم کامو، «فاتح» است. دلاوری که تمام وعده‌های جاودانگی در تاریخ بشریت را فراموش می‌کند. او عمل را
          بر
          تأمل ترجیح می‌دهد. با آگاهی از این واقعیت که هیچ چیز دوام ندارد و هیچ پیروزی ای همیشگی نیست.
          فصل ۳:خلقت پوچ
          <br><br>
          در اینجا کامو هنرمند یا خالق ابزورد را وا می‌کاود. از آنجاییکه توضیح ناممکن است، هنر ابزورد محدود به شرحی از
          تجارب فراوان در جهان است. «اگر دنیا واضح و آشکار بود، دیگر هنری وجود نداشت». همچنین خلقت ابزورد باید مانع از
          قضاوت و داوری و همچنین سایه ای حتی جزئی از امید بشود.
          <br><br>
          او سپس به تحلیل کارهای داستایفسکی، ازجمله ، ''دفتر یادداشت روزانهٔ یک نویسنده'' ، «جن زدگان»، و «برادران
          کارامازف» می‌پردازد. همهٔ اینها آغازی ابزورد دارند و دو مورد اول به خودکشی فلسفی می‌پردازد. هرچند کتاب خاطرات
          و
          رمان آخر او، برادران کارامازف، در نهایت راهی به امید می‌گشایند و در حقیقت نمی‌توان آنها را آفرینشهایی ابزورد
          تلقی کرد.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import card from '@/components/card.vue'

export default {
  name: 'HomeView',
  components: {
    card
  }
}
</script>
